module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": "/servicos-b2c"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar para planos\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back pull-right",
    attrs: {
      "to": "/servicos-b2c-plano-conforto"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Ver plano anterior\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Plano Pague Fácil")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-1"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "txt-row-1"
  }, [_c('span', [_vm._v("Com o plano "), _c('b', [_vm._v("PAGUE FÁCIL")]), _vm._v(" você só irá pagar quando utilizar o serviço. Funciona assim: toda vez que passar numa praça de pedágio iremos debitar o valor do pedágio + uma taxa de serviço de R$ 1,50.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "balloon"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "free_pass"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-2"
  }, [_c('h3', [_c('b', [_vm._v("Não precisa efetuar recargas e nem pagar mensalidade.")])]), _vm._v(" "), _c('p', [_vm._v("A forma de pagamento é o cartão de crédito e você pode adicionar quantos veículos quiser.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-3"
  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "gps-vehicle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-4"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "freedom-trip"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-4"
  }, [_c('h3', [_vm._v("Se você não quer amarras e ainda assim não perder tempo nas estradas, este é o seu plano.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "button"
    }
  }, [_vm._v("\n          Plano indisponível\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-62138004!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plan-movepay-b2c.vue
// module id = 2146
// module chunks = 1